(function(){
  function optionPlaceholder(select){
    if(!select||select.dataset.legacyIntentionalChoice==='1')return;
    var row=select.closest('.legacy-fashion-option');
    var label=row&&row.querySelector('label');
    var name=(label&&label.textContent||select.getAttribute('aria-label')||'Option').trim();
    var placeholder=select.querySelector('option[data-legacy-placeholder]');
    if(!placeholder){
      placeholder=document.createElement('option');
      placeholder.value='';
      placeholder.textContent='Choose '+name;
      placeholder.disabled=true;
      placeholder.dataset.legacyPlaceholder='1';
      select.insertBefore(placeholder,select.firstChild);
    }
    select.value='';
    select.dataset.legacyIntentionalChoice='1';
    select.dispatchEvent(new Event('change',{bubbles:true}));
  }

  function patchQuickShop(){
    document.querySelectorAll('.legacy-fashion-modal__options select').forEach(optionPlaceholder);
    document.querySelectorAll('.legacy-fashion-quickshop').forEach(function(button){
      var card=button.closest('.legacy-product-card,.legacy-best-card,.product-card-wrapper');
      if(!card)return;
      var jersey=card.classList.contains('legacy-product-card--jersey');
      if(!jersey){
        var text=(card.textContent||'').toLowerCase();
        jersey=text.indexOf('jersey')>-1;
      }
      var titleNode=card.querySelector('.legacy-product-card__title,.card__heading');
      var titleText=titleNode&&titleNode.textContent?titleNode.textContent.trim():'product';
      button.textContent=jersey?'CHOOSE OPTIONS':'QUICK SHOP';
      button.setAttribute('aria-label',(jersey?'Choose options for ':'Quick shop ')+titleText);
    });
    var modal=document.querySelector('.legacy-fashion-modal.is-open');
    if(modal){
      var modalTitle=modal.querySelector('.legacy-fashion-modal__details h2');
      var eyebrow=modal.querySelector('.legacy-fashion-modal__eyebrow');
      var modalJersey=modalTitle&&/jersey/i.test(modalTitle.textContent||'');
      if(eyebrow)eyebrow.textContent=modalJersey?'CHOOSE OPTIONS':'QUICK SHOP';
      modal.setAttribute('aria-label',modalJersey?'Choose product options':'Quick Shop');
      var close=modal.querySelector('.legacy-fashion-modal__close');
      if(close)close.setAttribute('aria-label',modalJersey?'Close product options':'Close Quick Shop');
    }
  }

  function selectedOptions(root){
    var values=[];
    root.querySelectorAll('product-variant-picker fieldset,variant-radios fieldset,variant-selects fieldset').forEach(function(fieldset){
      var checked=fieldset.querySelector('input[type="radio"]:checked');
      if(checked&&checked.value&&values.indexOf(checked.value)<0)values.push(checked.value);
    });
    root.querySelectorAll('product-variant-picker select,variant-selects select').forEach(function(select){
      if(select.value&&values.indexOf(select.value)<0)values.push(select.value);
    });
    return values;
  }

  function stickySummary(){
    var root=document.querySelector('product-info');
    var bar=document.querySelector('.legacy-mobile-sticky-buy');
    if(!root||!bar)return;
    var meta=bar.querySelector('.legacy-mobile-sticky-buy__info span');
    if(!meta)return;
    var price=root.querySelector('.price--large');
    var priceNode=null;
    if(price){
      priceNode=price.classList.contains('price--on-sale')?price.querySelector('.price__sale .price-item--sale'):price.querySelector('.price__regular .price-item--regular');
      if(!priceNode)priceNode=price.querySelector('.price-item--sale,.price-item--regular');
    }
    var priceText=priceNode?priceNode.textContent.replace(/\s+/g,' ').trim():'';
    var options=selectedOptions(root);
    meta.textContent=(options.length?options.join(' / ')+(priceText?' · ':''):'')+priceText;
  }


  function run(){
    patchQuickShop();
    stickySummary();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();

  document.addEventListener('change',function(event){
    if(event.target&&event.target.closest&&event.target.closest('product-info'))setTimeout(stickySummary,80);
    if(event.target&&event.target.closest&&event.target.closest('.legacy-fashion-modal'))setTimeout(patchQuickShop,0);
  });

  var queued=false;
  var observer=new MutationObserver(function(){
    if(queued)return;
    queued=true;
    requestAnimationFrame(function(){queued=false;run()});
  });
  if(document.documentElement)observer.observe(document.documentElement,{subtree:true,childList:true});

  document.addEventListener('shopify:section:load',function(){setTimeout(run,50)});
})();
